import React from 'react';
import { motion } from 'framer-motion';
import { cvData } from '../data/cvData';
import { uiTranslations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';
import SectionHeader from './SectionHeader';

export default function WorkStyle() {
  const { language } = useLanguage();
  const data = cvData[language];
  const t = uiTranslations[language].sections.workstyle;

  if (!data.work_style) return null;

  return (
    <section id="workstyle" className="py-24 bg-slate-50/50 border-t border-slate-100">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <SectionHeader title={t.title} label={t.label} />
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="space-y-8 max-w-4xl">
          {data.work_style.text.split('\n\n').map((paragraph, index) => (
            <p key={index} className="text-lg md:text-xl text-slate-600 leading-relaxed font-light">
              {paragraph}
            </p>
          ))}
        </motion.div>
      </div>
    </section>
  );
}